import { action, computed, makeObservable, observable } from "mobx";
import BaseService from "../base/BaseService";

/**
 * Service used to manage the wizard form's tabs.
 */
class TabsService extends BaseService {
	/**
	 * The tab currently active in the form wizard.
	 * @type {number}
	 */
	@observable
	currentFormTab;

	@observable
	tabsCount;

	constructor(props) {
		super(props);
		makeObservable(this);
	}

	@action
	setCurrentFormTab = (currentFormTab) => {
		this.currentFormTab = currentFormTab;
	};

	@action
	setTabsCount = (tabsCount) => {
		this.tabsCount = tabsCount;
	};

	@action
	goToNextFormTab = () => {
		if (this.tabsCount > this.currentFormTab + 1) {
			this.currentFormTab = this.currentFormTab + 1;
		} else if (this.tabsCount < this.currentFormTab + 1) {
			this.currentFormTab = this.tabsCount - 1;
		}
	};

	@action
	goToPreviousFormTab = () => {
		if (this.currentFormTab > 0) {
			this.currentFormTab = this.currentFormTab - 1;
		} else if (this.currentFormTab < 0) {
			this.currentFormTab = 0;
		}
	};

	@action
	goToFormTab = (index) => {
		if (index >= 0 && index < this.tabsCount) {
			this.currentFormTab = index;
		}
	};

	@computed
	get isOnLastFormTab() {
		return this.tabsCount === this.currentFormTab + 1;
	}

	@computed
	get isOnFirstFormTab() {
		return this.currentFormTab === 0;
	}

	@computed
	get nextFormTab() {
		if (this.tabsCount > this.currentFormTab + 1) {
			return this.currentFormTab + 1;
		} else if (this.tabsCount < this.currentFormTab + 1) {
			return this.tabsCount - 1;
		}
	}

	@computed
	get previousFormTab() {
		if (this.currentFormTab > 0) {
			return this.currentFormTab - 1;
		} else if (this.currentFormTab < 0) {
			return 0;
		}
	}
}

export default TabsService;
